<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';

import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

Vue.use(BootstrapVue);

export default {
  name: 'App',
  mounted() {
    this.checkIfResize({}, this.informParent);
    this.informParent();
  },
  methods: {
    checkIfResize(elm, callback) {
      let newHeight;
      let lastHeight = this.getHeight();
      const run = () => {
        newHeight = this.getHeight();
        if (lastHeight !== newHeight) callback();
        lastHeight = newHeight;
        if (elm.onElementHeightChangeTimer) clearTimeout(elm.onElementHeightChangeTimer);
        elm.onElementHeightChangeTimer = setTimeout(run, 150);
      };
      run();
    },
    getHeight() {
      const body = document.body;
      const html = document.documentElement;
      return Math.max(body.scrollHeight, body.offsetHeight, html.offsetHeight);
    },
    informParent() {
      const height = this.getHeight();
      window.parent.postMessage(JSON.stringify({ height }), '*');
    }
  }
};
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Nunito');

#app {
  font-family: 'Nunito', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: white;
  min-height: 650px;
}

.btn:hover,
.btn:active,
.btn.selected {
  background-color: rgb(118, 35, 106) !important;
}

.content {
  padding: 50px 20px;
}

.title-sm {
  font-size: 3rem;
}
.round-border {
  border-radius: 0.5em;
}
.subheading {
  font-size: 1.5rem;
}

.col {
  padding: 15px;
}

.icon-btn {
  background-color: transparent;
  border: none;
  color: white;
  padding: 12px;
}

.btn-lg {
  background-color: rgb(0, 82, 136);
  border: none;
  border-radius: 0.5em;
}

.material-icons.md-36 {
  font-size: 36px;
}
</style>
